export class ProductionJobUpdate {

    public jobId : string;
    
    public runId : number|string;
    
}